export async function submitInteractiveWidgetCompletion({
  toolCallId,
  isLoading = false,
  isPending = false,
  sendMessage,
  registerPendingSubmission,
  clearPendingSubmission,
  completionMessage,
  completedData = {},
}) {
  if (isLoading || isPending || !toolCallId) {
    return false;
  }

  const message =
    typeof completionMessage === 'function'
      ? completionMessage(completedData)
      : completionMessage;

  registerPendingSubmission(toolCallId);

  try {
    await Promise.resolve(sendMessage(message));
    return true;
  } catch (error) {
    clearPendingSubmission(toolCallId);
    console.error(
      '[useInteractiveWidgetSubmit] failed to submit widget completion:',
      error,
    );
    return false;
  }
}
